import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Toolbar as DXToolbar} from 'devextreme-react/toolbar';


export default class Toolbar extends Component {
    constructor(props) {
        super(props);

        this.menuItemTemplate = this.menuItemTemplate.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
    }

    menuItemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            // const d = window.document.createElement('div');
            ReactDOM.render(tmpl(itemData), element);
            // element.append(d.firstChild);
        }
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        let {menuItemTemplate, itemTemplate} = this.props;

        if (menuItemTemplate && typeof menuItemTemplate === 'string' && menuItemTemplate !== 'menuItem'){
            menuItemTemplate = this.menuItemTemplate(menuItemTemplate);
        }

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        return (
            <DXToolbar
                {...omit(['loading_state', 'setProps', 'children'], this.props)}
                {...dataAttributes}
                menuItemTemplate={menuItemTemplate}
                itemTemplate={itemTemplate}
            >
                {this.props.children}
            </DXToolbar>
        )
    }
}

Toolbar.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    children: PropTypes.node,

    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * The time period in milliseconds before the onItemHold event is raised
     */
    itemHoldTimeout: PropTypes.number,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object), PropTypes.node]),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * An alias for the menuItemTemplate property specified in React. Accepts a custom component.
     */
    menuItemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the menuItemTemplate property specified in React. Accepts a rendering function.
     */
    menuItemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for menu items.
     */
    menuItemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed when a collection item is right-clicked or pressed
     */
    onItemContextMenu: PropTypes.func,
    /**
     * A function that is executed when a collection item has been held for a specified period
     */
    onItemHold: PropTypes.func,
    /**
     * A function that is executed after a collection item is rendered
     */
    onItemRendered: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Toolbar.defaultProps = {
    dataSource: null,
    disabled: false,
    elementAttr: {},
    // hint: undefined,
    hoverStateEnabled: true,
    itemComponent: null,
    itemHoldTimeout: 750,
    itemRender: null,
    items: undefined,
    itemTemplate: 'item',
    menuItemComponent: null,
    menuItemRender: null,
    menuItemTemplate: 'menuItem',
    noDataText: 'No data to display',
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onItemContextMenu: null,
    onItemHold: null,
    onItemRendered: null,
    onOptionChanged: null,
    rtlEnabled: false,
    visible: true,
    width: 'auto'
};
